import './App.css';
import './custom.css';
import { useRoutes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';
import ContactPage from './pages/ContactPage';
import ProjectsPage from './pages/ProjectsPage';
import LifeSafetyAIPage from './pages/LifeSafetyAIPage';


const routes = [
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'aboutme', element: <AboutPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
      { path: 'terms', element: <TermsPage /> },
      { path: 'blog', element: <BlogList /> },
      { path: 'blog/:slug', element: <BlogPost /> },
      { path: 'projects', element: <ProjectsPage /> },
      { path: 'lifesafetyai', element: <LifeSafetyAIPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: '*', element: <NotFoundPage /> },
    ]
  },
];

function App() {
  return useRoutes(routes);
}

export default App;
